import { render, staticRenderFns } from "./profiles.vue?vue&type=template&id=49c06738&scoped=true&lang=pug&"
import script from "./profiles.vue?vue&type=script&lang=ts&"
export * from "./profiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c06738",
  null
  
)

export default component.exports